// Worked examples for Sprint Mix. Illustrative: a made-up startup's sprint during
// customer discovery, with an agentic build team and a design + product team.
// Addressable as #example=<id>.

export const EXAMPLES = [
  {
    id: "discovery-sprint",
    name: "Startup in customer discovery",
    description: "Agents build, design and product run interviews and a fake door. Illustrative.",
    state: {
      valueUnit: "€k",
      capacityUnit: "days",
      dayValue: 0.6,
      capacity: { build: { low: 18, high: 30 }, discovery: { low: 8, high: 12 } },
      items: [
        { label: "Self-serve onboarding", kind: "deliver", team: "build", value: { low: -5, high: 40 }, valueIn: "value", size: { low: 4, high: 12 }, },
        { label: "CSV import", kind: "deliver", team: "build", value: { low: 2, high: 10 }, valueIn: "value", size: { low: 1, high: 3 } },
        { label: "Clickable pricing prototype", kind: "learn", team: "build", value: { low: 3, high: 8 }, valueIn: "value", size: { low: 1, high: 2 } },
        { label: "Test harness for the agents", kind: "improve", team: "build", value: { low: 5, high: 25 }, valueIn: "days", size: { low: 3, high: 6 } },
        { label: "Usage-based billing", kind: "deliver", team: "build", value: { low: -10, high: 30 }, valueIn: "value", size: { low: 8, high: 20 } },
        { label: "Eight customer interviews", kind: "learn", team: "discovery", value: { low: 4, high: 12 }, valueIn: "value", size: { low: 4, high: 6 } },
        { label: "Fake door: team plan", kind: "learn", team: "discovery", value: { low: 1, high: 6 }, valueIn: "value", size: { low: 1, high: 2 } },
        { label: "Onboarding flow design", kind: "deliver", team: "discovery", value: { low: 2, high: 9 }, valueIn: "value", size: { low: 3, high: 5 } },
      ],
    },
  },
  {
    id: "growth-sprint",
    name: "Product team, two-week sprint",
    description: "Features, one experiment and a refactor, in points. Illustrative.",
    state: {
      valueUnit: "€k",
      capacityUnit: "points",
      dayValue: 0.8,
      capacity: { build: { low: 30, high: 42 }, discovery: { low: 5, high: 8 } },
      items: [
        { label: "Saved searches", kind: "deliver", team: "build", value: { low: 5, high: 20 }, valueIn: "value", size: { low: 5, high: 13 } },
        { label: "Faster checkout", kind: "deliver", team: "build", value: { low: -2, high: 25 }, valueIn: "value", size: { low: 8, high: 13 } },
        { label: "Split the billing module", kind: "improve", team: "build", value: { low: 8, high: 30 }, valueIn: "days", size: { low: 5, high: 8 } },
        { label: "Randomized rollout of new search", kind: "learn", team: "build", value: { low: 4, high: 10 }, valueIn: "value", size: { low: 3, high: 5 } },
        { label: "Dark mode", kind: "deliver", team: "build", value: { low: 0, high: 4 }, valueIn: "value", size: { low: 3, high: 8 } },
        { label: "Churn interviews", kind: "learn", team: "discovery", value: { low: 2, high: 8 }, valueIn: "value", size: { low: 3, high: 5 } },
      ],
    },
  },
];

export function exampleById(id) {
  return EXAMPLES.find((e) => e.id === id) ?? null;
}
